"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// DATE FORMATTING
_moment.default.locale(['en-AU']); //Set moment to default to AUS format


var DateUtils = function DateUtils() {
  _classCallCheck(this, DateUtils);
};

exports.default = DateUtils;

_defineProperty(DateUtils, "formatDateFromISO", function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return value ? (0, _moment.default)(value).format(format) : null;
});

_defineProperty(DateUtils, "formatDateFromISONoUTC", function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return value ? _moment.default.parseZone(value).format(format) : null;
});

_defineProperty(DateUtils, "formatDateTimeFromISO", function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY hh:mm';
  return value ? (0, _moment.default)(value).format(format) : null;
});

_defineProperty(DateUtils, "formatToISO", function (value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  return value ? (0, _moment.default)(value, format).format() : null;
});
//# sourceMappingURL=DateUtils.js.map